<template>
  <div class="bizReport-bd tb" v-if="funcView.customer_biz_report_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-radio-group v-model="formSearch.orgType" @change="onPageChange({ page: 1 })" v-if="bizType === 'JV_SC'">
          <el-radio-button :label="item.value" v-for="(item, index) in orgTypeData" :key="index">{{ item.label }}</el-radio-button>
        </el-radio-group>
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" @click="exportTable" v-if="funcView.customer_biz_report_export" :disabled="exporting">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="$t('report_customerBizReport.he_tong_bian_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="funcView.customer_biz_report_refresh">
          <el-button @click="onRefresh(1)" :disabled="asyncing1">
            <i class="icon icon-shuaxin"></i>
            {{ funcView.customer_biz_report_refresh }}
            <span v-if="asyncing1">（{{ $t('report_customerBizReport.shua_xin_zhong') }}... ）</span>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="funcView.customer_biz_report_refresh_Payment">
          <el-button @click="onRefresh(2)" :disabled="asyncing2">
            <i class="icon icon-shuaxin"></i>
            {{ funcView.customer_biz_report_refresh_Payment }}
            <span v-if="asyncing2">（{{ $t('report_customerBizReport.shua_xin_zhong') }}... ）</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
      <el-form :inline="true" label-position="top">
        <!-- <el-form-item :label="$t('p_customerBizReport_he_tong_bian_hao')" prop="contractNo">
          <el-input
            v-model="formSearch.contractNo"
            :placeholder="$t('p_customerBizReport_he_tong_bian_hao')"
          ></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('report_customerBizReport.ji_shen_hao')" prop="bodyNum" style="width: 12.5%">
          <el-input v-model="formSearch.bodyNum" :placeholder="$t('report_customerBizReport.ji_shen_hao')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_customerBizReport.she_bei_hao')" prop="deviceNo" style="width: 12.5%">
          <el-input v-model="formSearch.deviceNo" :placeholder="$t('report_customerBizReport.she_bei_hao')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('report_customerBizReport.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- partnerSelectOrgan  childOrgType: 'CO' // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS -->
        <el-form-item :label="$t('report_customerBizReport.dai_li_gong_si')">
          <custom-select
            url="partnerSelectPartnerLimit"
            filterable
            remote
            v-model="formSearch.agentCoName"
            :props="{ label: 'partnerName', value: 'partnerName' }"
            :params="{ num: 50, orgTypeList: ['JV'] }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_customerBizReport.shou_hou_gong_si')">
          <custom-select
            url="partnerSelectPartnerLimit"
            filterable
            remote
            v-model="formSearch.afterServiceName"
            :props="{ label: 'partnerName', value: 'partnerName' }"
            :params="{ num: 50, orgTypeList: ['SC'] }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_customerBizReport.zu_lin_fang')">
          <custom-select
            url="partnerSelectPartnerLimit"
            filterable
            remote
            v-model="formSearch.customerName"
            :props="{ label: 'partnerName', value: 'partnerName' }"
            :params="{ num: 50, orgTypeList: ['CS'] }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_customerBizReport.xiang_mu_ming_cheng')">
          <custom-select
            url="locationList"
            :listener="`${orgId}`"
            filterable
            v-model="formSearch.locationName"
            :props="{ label: 'locationName', value: 'locationId' }"
            :params="{ orgId: orgId }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>

        <el-form-item :label="$t('report_customerBizReport.zu_lin_fang_an')" prop="goodsName">
          <el-input v-model="formSearch.goodsName" :placeholder="$t('report_customerBizReport.zu_lin_fang_an')"></el-input>
        </el-form-item>
        <!-- 日期 -->
        <el-form-item :label="$t('report_customerBizReport.qi_zu_ri_qi')">
          <custom-date-picker
            v-model="formSearch.rentalStartTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_customerBizReport.ti_jiao_ri_qi')">
          <custom-date-picker
            v-model="formSearch.submitDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 张鹏说比较复杂先注释 -->
        <!-- <el-form-item :label="$t('p_customerBizReport_qrsksj')">
          <custom-date-picker
            v-model="formSearch.receiveConfirmTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item> -->
        <el-form-item :label="$t('report_customerBizReport.zhong_zhi_ri_qi')">
          <custom-date-picker
            v-model="formSearch.endRentDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_customerBizReport.sheng_xiao_ri_qi')">
          <custom-date-picker
            v-model="formSearch.effectiveDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_customerBizReport.ye_wu_yuan')">
          <el-input v-model="formSearch.salesman" :placeholder="$t('Common.com_please_input')"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('p_customerBizReport_qdfs')">
          <custom-select
            code="signing_method"
            v-model="formSearch.signingMethod"
            :placeholder="$t('com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item> -->
      </el-form>
    </switch-container>
    <div class="progress" v-if="asyncing1 || asyncing2">
      <p>{{ asyncing1 ? $t('report_customerBizReport.sjsxjd') : $t('report_customerBizReport.sfkxxsxjd') }}</p>
      <el-progress :percentage="percentage" color="#0D9AE0"></el-progress>
    </div>
    <!-- {{slotsArr}} -->
    <div class="table-bd">
      <custom-table
        index
        type="radio"
        v-loading="isLoading"
        :loading="isLoading"
        v-model="selectedRow"
        :data="tableList"
        :column="tableColumn"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['rentalTerm', 'totalRentalDays', 'receivedRentalTotalAmount', ...slotsArr]"
      >
        <template v-for="(item, index) in slotsArr" :slot="item" slot-scope="scope">
          <!-- 组合成是73列 过半就要减36 -->
          <p :key="index" v-if="index >= slotsArr.length / 2">
            <!-- {{index-slotsArr.length/2}} -->
            {{ scope.row.paymentList.length > index - slotsArr.length / 2 ? `${scope.row.paymentList[index - slotsArr.length / 2].tradeAmount}` || '-' : '-' }}
          </p>
          <p :key="index" v-else>
            <!-- {{index}} -->
            {{ scope.row.paymentList.length > index ? $momentLocal(scope.row.paymentList[index].tradeConfirmTime, 'YYYY-MM-DD') || '-' : '-' }}
          </p>
        </template>
        <template slot="receivedRentalTotalAmount" slot-scope="scope">
          {{ (scope.row.receivedRentalAmount || 0 + scope.row.receivedOverdueAmount || 0 + scope.row.receivedBreakAmount || 0).toFixed(2) }}
        </template>
        <template slot="totalRentalDays" slot-scope="scope">
          {{ scope.row.totalRentalDays ? Number.parseInt(scope.row.totalRentalDays / 30.5) : '-' }}
        </template>
        <template slot="rentalTerm" slot-scope="scope">{{ scope.row.rentalTerm || '-' }}{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import qs from 'qs';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'customerBizReport',
  mixins: [resetFormSearchMixins],
  data() {
    return {
      tableCode: 'customerBizReport',
      // tableCode: 'notice',
      // provide: true,
      // translate: { i18n, funcView },
      formSearch: {
        search: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        keyword: '',
        contractNo: '', // 合同编号 文本输入框
        bodyNum: '', // 机身号 文本输入框
        deviceNo: '', // 设备号 文本输入框
        productCode: '', // 产品型号 下拉选择
        orderType: '', // crm_contract_type 订单类型 表头下拉选择
        orderBizState: '', // crm_contract_biz_state 订单状态 表头下拉选择
        deviceBizType: '', // dms_device_biz_type 设备类型 表头下拉选择
        bizState: '', //  order_device_biz_state 设备状态 表头下拉选择
        receivableOrgType: '', // bas_organ_type 收款方类型  表头下拉选择
        agentCoName: '', // 代理公司 下拉输入选
        afterServiceName: '', // 售后公司 下拉输入选
        customerName: '', // 租赁方 下拉输入选
        locationName: '', // 项目名称 下拉输入选
        goodsName: '', // 租赁方案 文本输入框
        rentalStartTime: [], // 启租日期 日期区间
        submitDate: [], // 签订日期 日期区间
        receiveConfirmTime: [], // 确认收款时间 日期区间
        endRentDate: [], // 终止日期 日期区间
        effectiveDate: [], // 生效日期 日期区间
        signingMethod: '', // 签订方式 signing_method 表头下拉选择
        orgType: '',
        salesman: ''
      },

      invoiceTime: [],

      totalRows: null,
      isLoading: false,
      tableList: [],
      selectedRow: {},

      indexNotice: [],
      link: null,
      exporting: false,
      asyncing1: false,
      asyncing2: false,
      totalTasks: 0,
      remain: 0,
      timer1: null,
      timer2: null,
    };
  },
  computed: {
    orgTypeData() {
      return [
        // '代理公司'
        {
          label: this.$t('report_customerBizReport.dai_li_gong_si'),
          value: 'JV',
        },
        // '售后公司'
        {
          label: this.$t('report_customerBizReport.shou_hou_gong_si'),
          value: 'SC',
        },
      ];
    },
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
    bizType() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.bizType : '';
    },
    slotsArr() {
      const arr = new Array(36).fill(1).map((item, index) => index);
      // tradeConfirmTime1
      const tradeConfirmTimeArr = arr.map((item, index) => `tradeConfirmTime${index + 1}`);
      // tradeAmount1
      const tradeAmountArr = arr.map((item, index) => `tradeAmount${index + 1}`);
      return [...tradeConfirmTimeArr, ...tradeAmountArr];
    },
    percentage() {
      const num = this.remain > 0 && this.totalTasks - this.remain > 0 ? this.totalTasks - this.remain : 0;
      return Math.round((num / this.totalTasks) * 100) || 0;
    },
  },

  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  beforeDestroy() {
    clearInterval(this.timer1);
    clearInterval(this.timer2);
  },
  methods: {
    getTableList: function () {
      // 是空不传
      this.formSearch.gmtCreate = this.formSearch.gmtCreate || undefined;
      // 服务公司要特殊处理 默认选代理
      if (!this.formSearch.orgType) {
        this.formSearch.orgType = this.bizType === 'JV_SC' ? 'JV' : this.bizType;
      }
      this.isLoading = true;
      this.$getJSON(apis.staRevenueOrderBillPage, this.formSearch).then((res) => {
        this.isLoading = false;
        const recordsData = res.data.records;
        // // 推送对象  消息推送方式 数组变字符串用于展示
        // recordsData.forEach((i) => {
        //   const pushRoleNameString = i.pushRoleName.join(',');
        //   i.pushRoleName = pushRoleNameString;
        //   const pushChannelNameString = i.pushChannelName.join(',');
        //   i.pushChannelName = pushChannelNameString;
        //   const pushRangeNameString = i.pushRangeName.join(',');
        //   i.pushRangeName = pushRangeNameString;
        // });
        this.tableList = recordsData;

        this.totalRows = res.data.total;
      });
    },
    onRefresh: function (type) {
      let refreshApi = '';
      let progressApi = '';
      const formSearch = {};
      // 刷新报表
      if (type === 1) {
        refreshApi = apis.staRevenueOrderBillRefresh;
        progressApi = apis.staRevenueOrderBillRefreshProgress;
        formSearch.rentalStartTime = this.formSearch.rentalStartTime; // 签订日期
        formSearch.submitDate = this.formSearch.submitDate; // 日期区间
      } else {
        // 刷新首付款
        refreshApi = apis.staRevenueOrderBillRefreshPayment;
        progressApi = apis.staRevenueOrderBillRefreshPaymentProgress;
        formSearch.receiveConfirmTime = this.formSearch.receiveConfirmTime; // 确认收款时间
      }
      this.$getJSON(refreshApi, formSearch).then((res) => {
        this.totalTasks = res.data;
        this[`asyncing${type}`] = true;
        this[`timer${type}`] = setInterval(() => {
          this.$getJSON(progressApi).then((progress) => {
            this.remain = progress.data;
            if (this.remain < 1) {
              clearInterval(this[`timer${type}`]);
              this[`timer${type}`] = null;
              this.remain = 0;
              this[`asyncing${type}`] = false;
              this.onPageChange({ page: 1 });
            }
          });
        }, 5000);
      });
    },

    // 导出
    exportTable: function () {
      const param = {};
      Object.keys(this.formSearch).forEach((key) => {
        const val = this.formSearch[key];
        if (val) {
          param[key] = val;
        }
      });
      delete param.pageSize;
      delete param.pageNum;
      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });
      const headerList = this.tableColumn
        .filter(t => t.isExport)
        .map(i => ({ columnCode: i.columnCode, columnName: i.columnName, width: i.width, isFormat: i.isFormat, formatRule: i.formatRule, dicGroup: i.dicGroup }));
      const reqData = {
        exportName: this.$t('report_customerBizReport.ke_fu_bao_biao'),
        headerList: headerList,
      };
      this.exporting = true;
      // 'staRevenueOrderBillExport', formSearch;
      this.$exportFliePost(`${apis.staRevenueOrderBillExport}?${pathParms}`, reqData)
        .then(() => {
          this.exporting = false;
        })
        .catch(() => {
          this.exporting = false;
          this.$message.error(this.$t('report_customerBizReport.dao_chu_shi_bai'));
        });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '../../../style/colors.scss';

.bizReport-bd {
  .progress {
    padding: 10px 0;
    p {
      color: #6c757d;
      font-size: 14px;
    }
  }
}
</style>
